import dinerLogo from './logo-diner2.png';
import scenesLogo from './logo-scenes2.png';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import { List, ListItem, Typography} from '@mui/material';


export default function About() {
    return (
        <>
            
            <Divider sx={{mb: 10, height: 1, width: 800, backgroundColor: '#ffd700'}}></Divider>
            
        
            <Typography variant='h3' sx={{mb:2, fontFamily: 'Roboto'}}>DLZ Ventures LLC</Typography>
            <List>
                <ListItem sx={{justifyContent: 'center'}}><i>Mobile App Development</i></ListItem>
                <ListItem sx={{justifyContent: 'center'}}><i>Digital Products</i></ListItem>
                <ListItem sx={{justifyContent: 'center'}}><i>Creative Images and Apparel</i></ListItem>
            </List>

            <Divider sx={{mt: 10, mb: 10, height: 1, width: 800, backgroundColor: '#ffd700'}}></Divider>
        

            <Typography variant='h3' sx={{mb:2}}>About</Typography>        
                <Typography sx={{width: 600, fontSize: 20}}>
                    Our team builds mobile applications and related software services
                    to assist the efficency of everyday life. While adding some
                    light-hearted fun along the way.
                    We design, develop, and maintain apps for iOS and cross‑platform
                    environments.
                </Typography>

            <Divider sx={{mt: 10, height: 1, width: 800, backgroundColor: '#ffd700'}}></Divider>


            <p> 
                <img 
                    src={dinerLogo} 
                    className="diner-logo"
                    alt="logo" 
                    style={{height: 400, width: 500, margin: 0}} 
                />
            </p>
            <p>
                <img 
                    src={scenesLogo} 
                    className="scenes-logo" 
                    alt="logo" 
                    style={{height: 400, width: 450}} 
                />
            </p>

            <Divider sx={{mt: 10, mb: 2, height: 1, width: 800, backgroundColor: '#ffd700'}}></Divider>

            <footer>
                <small>© {new Date().getFullYear()} DLZ Ventures LLC</small>
            </footer>
            <Box sx={{ mt: 2, flexGrow: 1 , width: '100%'}}><Paper sx={{height:50, backgroundColor: '#000000'}}/></Box>

        </>
    )
  }